var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-preview"},[(_vm.user)?_c('div',{staticClass:"user-img",style:({ backgroundImage: ("url(" + (_vm.user.imgUrl))}),on:{"click":function($event){return _vm.$router.push('/profile')}}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }